/**
 * Stripe return URLs must stay on the origin the user is browsing.
 * Local default config uses 127.0.0.1; localhost is a loopback alias of the same app.
 */
export function currentBillingReturnOrigin(
  locationOrigin: string = typeof window !== "undefined" ? window.location.origin : "",
): string | undefined {
  if (!locationOrigin) {
    return undefined;
  }
  try {
    const url = new URL(locationOrigin);
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return undefined;
    }
    return url.origin;
  } catch {
    return undefined;
  }
}

export function withBillingReturnOrigin<T extends object>(
  body: T,
  origin: string | undefined = currentBillingReturnOrigin(),
): T & { return_origin?: string } {
  if (!origin) {
    return body;
  }
  return { ...body, return_origin: origin };
}
